import { memo, useState } from "react";
import { Accordion } from "../../common/accordion/accordion";
import { Curriculum } from "../../../model/bootcamp";

interface Props {
  data: Curriculum;
  showMoreTitle: string;
}

export const Programm = memo<Props>(({ data, showMoreTitle }) => {
  const [itemsToShow, setItemsToShow] = useState(5);

  function handleMorePoints() {
    setItemsToShow(data.list.length);
  }

  return (
    <>
      <div
        id="program"
        className="rounded-[16px] bg-day-base-base-100 pt-24 lg:pt-40 pl-4 pr-4 pb-36 lg:pb-45 lg:pl-20 lg:pr-20"
      >
        <h2
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.title,
          }}
          className="text-center"
        />
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.subtitle,
          }}
          className="m-auto max-w-[900px] p-7 pb-25 text-center text-[16px] leading-[130%] lg:text-[22px] lg:leading-[27px] text-night-base-base-400"
        />
      </div>
      <div className="relative">
        <div className="relative border rounded-[10px] lg:rounded-[20px] border-solid border-night-base-base-200 top-[-100px] m-auto w-[95%] bg-white lg:pt-6">
          {data.list.slice(0, itemsToShow).map((item, index) => (
            <Accordion
              index={index}
              key={item._key}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
        {itemsToShow < 6 && (
          <div className="absolute bottom-[50px] w-full">
            <div className="h-[150px] bg-gradient-to-t from-white flex justify-end"></div>
            <div
              onClick={handleMorePoints}
              className="cursor-pointer m-auto text-center w-max pt-6 pb-6 pl-10 pr-10 text-[16px] bg-day-base-base-100 rounded-[12px]"
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: showMoreTitle,
              }}
            />
          </div>
        )}
      </div>
    </>
  );
});
